// ./frontend/src/reducers/uiReducer.js
import {  
  SHOW_LOADER, 
  HIDE_LOADER, 
  SHOW_NOTIFICATION, 
  MODAL,
  THANK_YOU_MODAL,
  USER_PASSWORD,
	NOTIFICATION_MODAL
} from "../config"

const INITIAL_STATE={
  loader:false,
  notification:""
}
export function uiReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case SHOW_LOADER:
      state = {...state, loader:true};
      return state;
    case HIDE_LOADER:
      state = {...state,  loader:false};
      return state;
    case SHOW_NOTIFICATION:
      state = {...state, notification:action.message};
      return state;
	 case MODAL:
      state = {...state,modalHideShow:action.payload};
      return state;
	case NOTIFICATION_MODAL:
	  state = {...state,notificationFlag:action.payload};
	  return state;
	  case THANK_YOU_MODAL:
      state = {...state,hideShowThankYouModal:action.payload};
      return state;
	  case USER_PASSWORD:
      state = {...state,hideShowPassword:action.payload};
      return state;
    default:
      return state;
  }
}